<!--Desktop Header-->
<div
  [ngClass]="{ hidden: headerResponsivenessOptions.hideAssetsNavigation, sticky: config.sticky }"
  class="header header-container row pl-3 d-flex justify-content-between align-items-center"
>
  <div class="col-12">
    <app-navigation-component
      style="flex: 1"
      [config]="config"
      [headerResponsivenessOptions]="headerResponsivenessOptions"
    ></app-navigation-component>
  </div>
</div>

@if (fileReady && noDataStudio) {
  <div class="data-studio-notification bg-white border rounded p-3">
    <div class="d-flex justify-content-between mb-3">
      <span class="text-primary">
        <b>{{ 'DATA_STUDIO.POP_UP.TITLE' | translate }}</b>
      </span>
      <button
        type="button"
        class="close text-right close-pop-up"
        aria-label="Close"
        (click)="close()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-primary">
      <small>
        {{ 'DATA_STUDIO.POP_UP.YOUR_REQUESTED_FILE' | translate }}
        <b>{{ fileName }}</b>
        {{ 'DATA_STUDIO.POP_UP.IS_NOW_READY' | translate }}
      </small>
    </div>
    <div class="d-flex justify-content-between mt-3">
      <button
        class="btn btn-light custom-btn border text-primary"
        (click)="close()"
      >
        {{ 'DATA_STUDIO.POP_UP.ILL_CHECK_LATER' | translate }}
      </button>
      <button
        class="btn btn-primary custom-btn"
        (click)="goToDataStudio()"
      >
        {{ 'DATA_STUDIO.POP_UP.GO_TO_DATA_STUDIO' | translate }}
      </button>
    </div>
  </div>
}

<!--Mobile Header-->
<div [ngClass]="{ hidden: !headerResponsivenessOptions.hideAssetsNavigation }">
  <header class="header d-flex justify-content-between align-items-center px-3">
    @if (!hideNav) {
      <div class="d-flex align-items-center">
        <i
          data-testid="header-toggle-navigation"
          role="button"
          (click)="toggleHeader()"
          class="far fa-bars font-size-large text-primary clickable"
        ></i>
        @if (selectedLevel === 'portfolio') {
          <span class="ml-3 text-primary font-weight-bold">{{ selectedPortfolio?.name | capitalizeFirst }}</span>
        }
        @if (selectedLevel === 'park') {
          <span class="ml-3 text-primary font-weight-bold">{{ selectedPark?.name | capitalizeFirst }}</span>
        }
        @if (selectedLevel === 'turbine') {
          <span class="ml-3 text-primary font-weight-bold">
            @if (statusColor) {
              <i
                class="fas fa-circle turbine-status mr-1"
                [ngStyle]="{ color: statusColor | colorStatusCode: 'color' }"
                [ngClass]="{ 'outline-circle': statusColor === 5 }"
              ></i>
            }
            {{ selectedTurbine?.name | noUnderscore | capitalizeFirst }} ({{ selectedTurbine?.serial }})
          </span>
        }
      </div>
    }

    @if (!hideNav && selectedLevel === 'park') {
      <app-site-technology-buttons></app-site-technology-buttons>
    }

    <app-header-user-settings
      class="ml-auto"
      [headerResponsivenessOptions]="headerResponsivenessOptions"
    ></app-header-user-settings>
  </header>
  @if (defaultShown) {
    @if (headerOpen) {
      <div
        class="menu position-absolute"
        style="z-index: 1001"
        [ngClass]="headerOpen ? 'opened' : 'closed'"
      >
        <ul class="list-group">
          <li
            data-testid="header-show-portfolio"
            class="list-group-item py-3 rounded-0 d-flex justify-content-start pl-0 align-items-center cursor-pointer"
            [ngClass]="{ active: selectedLevel === 'portfolio', disabled: hidePortfolio }"
            (click)="showPortfolio()"
          >
            <div class="icon d-flex justify-content-center align-items-center">
              <i
                class="far fa-globe-americas portfolio-navigation-icon plant"
                [attr.aria-label]="'IMAGE_DESCRIPTION.PORTFOLIO_IMAGE' | translate"
                role="img">
              </i>
            </div>
            <div class="font-weight-bold text-primary">
              {{
                selectedLevel === 'portfolio'
                  ? (selectedPortfolio?.name | capitalizeFirst)
                  : ('COMMON.PORTFOLIO' | translate)
              }}
            </div>
            <div class="ml-3">
              <i
                class="fas font-size-medium text-primary"
                [ngClass]="{ 'fa-angle-left': portfolioShown, 'fa-angle-right': !portfolioShown }"
              ></i>
            </div>
          </li>
          <li
            data-testid="header-show-site"
            class="list-group-item py-3 rounded-0 d-flex justify-content-start pl-0 align-items-center cursor-pointer"
            [ngClass]="{ active: selectedLevel === 'park', disabled: hidePark }"
            (click)="showParks()"
          >
            <div class="icon d-flex justify-content-center align-items-center">
              <img
                [src]="'park-navigation' | imageSrc | async"
                class="plant"
                alt="icon"
              />
            </div>
            <div class="font-weight-bold text-primary">
              {{ selectedLevel === 'park' ? (selectedPark?.name | capitalizeFirst) : ('COMMON.PARKS' | translate) }}
            </div>
            <div class="ml-3">
              <i
                class="fas font-size-medium text-primary"
                [ngClass]="{ 'fa-angle-left': parksShown, 'fa-angle-right': !parksShown }"
              ></i>
            </div>
          </li>
          <li
            data-testid="header-show-turbine"
            class="list-group-item py-3 rounded-0 d-flex justify-content-start pl-0 align-items-center cursor-pointer"
            [ngClass]="{ active: selectedLevel === 'turbine', disabled: hideTurbine }"
            (click)="showTurbines()"
          >
            <div class="icon d-flex justify-content-center align-items-center">
              <img
                [src]="'turbine-navigation' | imageSrc | async"
                class="plant"
                alt="icon"
              />
            </div>
            <div class="font-weight-bold text-primary">
              {{
                selectedLevel === 'turbine'
                  ? (selectedTurbine?.name?.replaceAll?.('_', '') | capitalizeFirst)
                  : ('COMMON.TURBINES' | translate)
              }}
            </div>
            <div class="ml-3">
              <i
                class="fas font-size-medium text-primary"
                [ngClass]="{ 'fa-angle-left': turbinesShown, 'fa-angle-right': !turbinesShown }"
              ></i>
            </div>
          </li>
        </ul>
      </div>
    }
    @if (submenuOpen) {
      <div
        class="submenu position-absolute"
        style="z-index: 1050"
      >
        @if (portfolioShown) {
          <div>
            <div class="menu">
              <ul class="list-group">
                @for (portfolio of portfolios; track portfolio) {
                  <li
                    data-testid="header-set-default-portfolio"
                    [ngClass]="{ active: isPortfolioActive(portfolio.id) }"
                    [appScrollIntoView]="isPortfolioActive(portfolio.id)"
                    class="list-group-item asset-item rounded-0 d-flex justify-content-start pl-3 pr-3 align-items-center cursor-pointer"
                    (click)="navigateToPortfolio(portfolio)"
                  >
                    <div class="font-weight-bold text-primary">{{ portfolio?.name | capitalizeFirst }}</div>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
        @if (parksShown) {
          <div>
            <div class="menu">
              <ul class="list-group list-group-parks">
                @for (park of parks; track park) {
                  <li
                    [ngClass]="{ active: isParkActive(park.id) }"
                    [appScrollIntoView]="isParkActive(park.id) || isTurbineActiveFromPark(park.id)"
                    class="list-group-item asset-item rounded-0 d-flex justify-content-start pl-3 pr-3 align-items-center cursor-pointer"
                    (click)="navigateToPark(park)"
                  >
                    <div class="icon-signal mr-3">
                      @if (headerDropdownColorType === 'status') {
                        <span
                          class="fas fa-circle align-self-center"
                          [style.color]="park.status | colorStatusCode: 'color'"
                          [ngClass]="{ 'outline-circle': park?.status === 5 }"
                        ></span>
                      }
                      @if (headerDropdownColorType === 'load') {
                        <app-load-factor [loadFactor]="park?.load * 100"></app-load-factor>
                      }
                      @if (headerDropdownColorType === 'efficiency') {
                        <div class="efficiency-container">
                          <app-efficiency [efficiency]="park?.efficiency * 100"></app-efficiency>
                        </div>
                      }
                    </div>
                    <div class="font-weight-bold text-primary">{{ park?.name | capitalizeFirst }}</div>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
        @if (turbinesShown) {
          <div>
            <div class="menu">
              <ul class="list-group list-group-turbines">
                @for (turbine of turbines; track turbine) {
                  <li
                    data-testid="header-navigate-to-turbine"
                    [ngClass]="{ active: isTurbineActive(turbine._id) }"
                    [appScrollIntoView]="isFirstTurbineFromPark(turbine._id) || isTurbineActive(turbine._id)"
                    class="list-group-item asset-item rounded-0 d-flex justify-content-start pl-3 pr-3 align-items-center cursor-pointer"
                    (click)="navigateToTurbine(turbine)"
                  >
                    <div class="icon-signal mr-3">
                      @if (headerDropdownColorType === 'status') {
                        <span
                          class="fas fa-circle align-self-center"
                          [style.color]="turbine?.status | colorStatusCode: 'color'"
                          [ngClass]="{ 'outline-circle': turbine?.status === 5 }"
                        ></span>
                      }
                      @if (headerDropdownColorType === 'load') {
                        <app-load-factor [loadFactor]="turbine?.load * 100"></app-load-factor>
                      }
                      @if (headerDropdownColorType === 'efficiency') {
                        <div class="efficiency-container">
                          <app-efficiency [efficiency]="turbine?.efficiency * 100"></app-efficiency>
                        </div>
                      }
                    </div>
                    <div class="font-weight-bold text-primary">
                      {{ turbine?.name | noUnderscore | capitalizeFirst }}
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
